import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { UpdateWorkRequestParams } from '@/features/work/api/update-work-request/request';
import { updateWorkRequest } from '@/features/work/api/update-work-request/request';

export const useUpdateWorkRequestMutation = (
  settings?: MutationSettings<UpdateWorkRequestParams, typeof updateWorkRequest>
) =>
  useMutation({
    mutationKey: ['UpdateWorkRequest'],
    mutationFn: ({ params, config }) =>
      updateWorkRequest({
        params,
        config
      }),
    ...settings?.options
  });
